import styled from 'styled-components';

import {MOBILE_BREAKPOINT, PAGE_WIDTH} from './configurableLayer';

/*
 * Style.
 */

const StyledMainContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px;
  background-color: white;
  gap: 20px;
  border-radius: 18px;
  box-sizing: border-box;
  width: ${PAGE_WIDTH}px;
  margin-bottom: 8px;
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.3), 0px 3px 10px rgba(0, 0, 0, 0.1);

  @media screen and (max-width: ${MOBILE_BREAKPOINT}px) {
    width: 100%;
  }
`;

/*
 * Component.
 */

export const MainContentWrapper = StyledMainContentWrapper;
